try { 

// Product Navigation
var navigationBar = document.getElementById("uw_left_navigation_bar_ul");
// Get all buttons with class="btn" inside the container

var navigationList = navigationBar.getElementsByClassName("navigation_item");

// Loop through the buttons and add the active class to the current/clicked button
for (var i = 0; i < navigationList.length; i++) {
  navigationList[i].addEventListener("click", function() {
    var current = document.getElementsByClassName("uw_li_active");

    // If there's no active class
    if (current.length > 0) {
      current[0].className = current[0].className.replace(" uw_li_active", "");
    }

    // Add the active class to the current/clicked button
    this.className += " uw_li_active";
  });
}
  
} 

catch (error){
  
};